<div class="content">
  <ng-content></ng-content>
</div>
<i class="fal fa-times text-primary clickable" (click)="close.emit()"></i>
